export default "__VITE_ASSET__BUxp5PgQ__"